/**
 * Плагин: при клике по узлу показываем кнопку «Связь» (tool connect), при blank:click убираем.
 * У стикера (и других canvas-only узлов) инструмент не показываем — связи ArchiMate к ним нельзя.
 */
import {isCanvasOnlyNodeType, STICKER_SHAPE_ID} from '../util/CanvasNodeTypes';

function canShowConnectTool(modeler, node) {
	if (!node?.id) return false;
	const shape = typeof node.getShape === 'function' ? node.getShape() : node.shape;
	if (shape === STICKER_SHAPE_ID) return false;
	const dataType = node.getData?.()?.elementType;
	if (isCanvasOnlyNodeType(dataType)) return false;
	const viewElement = modeler?._findViewElementById?.(node.id);
	const type = viewElement && modeler?._getType?.(viewElement);
	if (isCanvasOnlyNodeType(type)) return false;
	return true;
}

export default {
	init(modeler, context) {
		const {graph} = context;
		let connectToolNodeId = null;

		const removeConnectTool = () => {
			if (!connectToolNodeId) return;
			const prev = graph.getCellById?.(connectToolNodeId);
			if (prev?.removeTool) prev.removeTool('connect');
			connectToolNodeId = null;
		};

		const onNodeClick = ({node}) => {
			removeConnectTool();
			if (!canShowConnectTool(modeler, node)) return;
			node.addTools?.([{name: 'connect'}]);
			connectToolNodeId = node.id;
		};

		graph.on('node:click', onNodeClick);
		graph.on('blank:click', removeConnectTool);

		return () => {
			graph.off('node:click', onNodeClick);
			graph.off('blank:click', removeConnectTool);
			removeConnectTool();
		};
	},
};
